<template>
  <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <mask
      id="mask0_312_5992"
      style="mask-type: luminance"
      maskUnits="userSpaceOnUse"
      x="3"
      y="3"
      width="19"
      height="18"
    >
      <path d="M3.50098 3.00003H21.501V21H3.50098V3.00003Z" fill="white" />
    </mask>
    <g mask="url(#mask0_312_5992)">
      <path
        d="M20.9736 12.2259C20.9736 14.2989 19.3091 16.0102 17.2361 16.0174C15.1585 16.0246 13.4721 14.3425 13.4721 12.2666L13.4721 12.2887C13.4721 11.7499 13.0197 11.2909 12.4809 11.2909C11.9421 11.2909 11.5052 11.7278 11.5052 12.2666C11.5052 14.3639 9.80927 15.9854 7.70173 15.9448C5.65472 15.9054 4.02832 14.2063 4.02832 12.1589C4.02832 9.85244 5.89807 7.98269 8.20453 7.98269H16.7974C19.1039 7.98269 20.9736 9.85244 20.9736 12.1589V12.2259Z"
        class="stroke-current"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9.5585 12.3106C9.5585 12.8738 8.78604 13.3304 7.8332 13.3304C6.88033 13.3304 6.10791 12.8738 6.10791 12.3106C6.10791 11.7475 6.88033 11.2909 7.8332 11.2909C8.78604 11.2909 9.5585 11.7475 9.5585 12.3106Z"
        class="stroke-current"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M18.8451 12.3106C18.8451 12.8738 18.0727 13.3304 17.1198 13.3304C16.1669 13.3304 15.3945 12.8738 15.3945 12.3106C15.3945 11.7475 16.1669 11.2909 17.1198 11.2909C18.0727 11.2909 18.8451 11.7475 18.8451 12.3106Z"
        class="stroke-current"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
  </svg>
</template>
